<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<div
	class="note-editor-modal-content"
	[class.note-editor-v2]="isV2()"
	[class.note-editor-v2--create]="isV2() && isCreateMode()"
>
	<form [formGroup]="form" novalidate (ngSubmit)="save()">
		@if (isV2()) {
			<button
				type="button"
				class="note-editor-v2-close"
				(click)="close()"
				[attr.aria-label]="'NOTE_EDITOR__CLOSE' | transloco"
			>
				<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">
					close
				</span>
			</button>
		}

		@if (noteTemplate?.name) {
			<div class="note-editor-heading" [class.ion-padding]="!isV2()">{{ noteTemplate.name }}</div>
		}

		@if (isCreateMode()) {
			@if (noteTemplate == null) {
				<div class="note-editor-heading" [class.ion-padding]="!isV2()">
					{{ "NOTE_EDITOR__CREATE_NOTE" | transloco }}
				</div>
			}

			@if (isV2()) {
				<div class="note-editor-v2-create">
					<div class="note-editor-v2-create-grid">
						<div class="note-editor-v2-create-col">
							<ng-container *ngLet="templates$ | async as templates">
								@if (templates?.length > 0) {
									<div
										class="note-editor-v2-field"
										[style.--template-bar-color]="selectedTemplate?.color || 'transparent'"
									>
										<span class="note-editor-v2-field-label">
											{{ "NOTE_EDITOR__CHOOSE_TEMPLATE" | transloco }}*
										</span>
										<button
											type="button"
											id="note-v2-template-trigger"
											class="note-editor-v2-control note-editor-v2-select-trigger"
											[class.note-editor-v2-select-trigger--placeholder]="!selectedTemplate"
										>
											@if (selectedTemplate?.color) {
												<span
													class="note-editor-v2-template-bar"
													aria-hidden="true"
												></span>
											}
											<span class="note-editor-v2-select-label">
												{{
													selectedTemplate?.name ||
														("NOTE_EDITOR__TEMPLATE_PLACEHOLDER" | transloco)
												}}
											</span>
											<span
												class="material-symbols-outlined material-symbols-outlined--size-24"
												aria-hidden="true"
											>
												arrow_drop_down
											</span>
										</button>
										<ion-popover
											trigger="note-v2-template-trigger"
											[dismissOnSelect]="true"
											[keepContentsMounted]="true"
											size="cover"
											side="bottom"
											alignment="start"
											cssClass="rideops-template-select-popover"
										>
											<ng-template>
												<div class="rideops-template-select-menu">
													<button
														type="button"
														class="rideops-template-select-option"
														[class.rideops-template-select-option--selected]="
															!selectedTemplate
														"
														(click)="clearTemplate()"
													>
														<span class="rideops-template-select-bar"></span>
														<span class="rideops-template-select-name">
															{{ "NOTE_EDITOR__TEMPLATE_NONE" | transloco }}
														</span>
													</button>
													<button
														type="button"
														class="rideops-template-select-option"
														*ngFor="let template of templates"
														[class.rideops-template-select-option--selected]="
															template.id === selectedTemplate?.id
														"
														(click)="selectTemplate(template)"
													>
														<span
															class="rideops-template-select-bar"
															[style.background]="template.color"
														></span>
														<span class="rideops-template-select-name">
															{{ template.name }}
														</span>
													</button>
												</div>
											</ng-template>
										</ion-popover>
									</div>
								}
							</ng-container>

							<div class="note-editor-v2-field">
								<span class="note-editor-v2-field-label">
									{{ "NOTE_EDITOR__TITLE" | transloco }}*
								</span>
								<ion-input
									appAutoFocus
									class="note-editor-v2-control note-editor-title-input"
									formControlName="title"
									autocomplete="off"
									[placeholder]="'NOTE_EDITOR__TITLE_PLACEHOLDER' | transloco"
								></ion-input>
							</div>

							<div class="note-editor-v2-field note-editor-v2-field--description">
								<span class="note-editor-v2-field-label">
									{{ "NOTE_EDITOR__DESCRIPTION" | transloco }}
								</span>
								<div class="note-editor-v2-control note-editor-v2-control--quill">
									<div class="quill-wrap">
										<quill-editor [modules]="modules" formControlName="description"></quill-editor>
									</div>
								</div>
							</div>
						</div>

						<div class="note-editor-v2-create-col">
							<ng-container *ngIf="noteTypes$ | async as types">
								<div class="note-editor-v2-field" [hidden]="types.length < 2">
									<span class="note-editor-v2-field-label">
										{{ "NOTE_EDITOR__TYPE" | transloco }}*
									</span>
									<button
										type="button"
										id="note-v2-type-trigger"
										class="note-editor-v2-control note-editor-v2-select-trigger"
										[class.note-editor-v2-select-trigger--placeholder]="!form.controls['type'].value"
									>
										<span class="note-editor-v2-select-label">
											{{
												typeLabel(types) ||
													("NOTE_EDITOR__TYPE_PLACEHOLDER" | transloco)
											}}
										</span>
										<span
											class="material-symbols-outlined material-symbols-outlined--size-24"
											aria-hidden="true"
										>
											arrow_drop_down
										</span>
									</button>
									<ion-popover
										trigger="note-v2-type-trigger"
										[dismissOnSelect]="true"
										[keepContentsMounted]="true"
										size="cover"
										side="bottom"
										alignment="start"
										cssClass="rideops-template-select-popover"
									>
										<ng-template>
											<div class="rideops-template-select-menu">
												<button
													type="button"
													class="rideops-template-select-option"
													*ngFor="let type of types"
													[class.rideops-template-select-option--selected]="
														type.id === form.controls['type'].value
													"
													(click)="selectType(type.id)"
												>
													<span class="rideops-template-select-bar"></span>
													<span class="rideops-template-select-name">
														{{ type.name }}
													</span>
												</button>
											</div>
										</ng-template>
									</ion-popover>
								</div>
							</ng-container>

							<div class="note-editor-v2-field">
								<span class="note-editor-v2-field-label">
									{{ "NOTE_EDITOR__ADD_MEDIA" | transloco }}
								</span>
								<app-attachments
									formControlName="attachments"
									[showAttachments]="true"
									[hideHeadline]="true"
									[isReadonly]="false"
									[v2]="true"
								></app-attachments>
							</div>
						</div>
					</div>
				</div>
			} @else {
				<ng-container *ngLet="templates$ | async as templates">
					@if (templates?.length > 0) {
						<app-grouping [label]="'NOTE_EDITOR__TEMPLATES'">
							<div class="template-buttons">
								<ion-button
									class="template-button"
									*ngFor="let template of templates"
									(click)="selectTemplate(template)"
									[ngStyle]="{ '--background': template.color }"
									[ngClass]="{
										disabled: selectedTemplate && selectedTemplate.id != template.id,
									}"
								>
									<ion-icon
										name="checkmark-circle-outline"
										slot="start"
										*ngIf="template.id == selectedTemplate?.id"
									></ion-icon>
									{{ template.name }}
								</ion-button>
							</div>
						</app-grouping>
					}
				</ng-container>

				<app-grouping [label]="'NOTE_EDITOR__TITLE'">
					<ion-input
						appAutoFocus
						class="note-editor-title-input"
						formControlName="title"
						autocomplete="off"
					></ion-input>
				</app-grouping>

				<app-grouping [label]="'NOTE_EDITOR__DESCRIPTION'" class="note-editor-description-grouping">
					<div class="note-editor-description-body">
						<div class="quill-wrap">
							<quill-editor [modules]="modules" formControlName="description"></quill-editor>
						</div>
					</div>
				</app-grouping>

				<ng-container *ngIf="noteTypes$ | async as types">
					<app-grouping [label]="'NOTE_EDITOR__TYPE'" [hidden]="types.length < 2">
						<ion-select
							formControlName="type"
							interface="popover"
							placeholder="{{ 'NOTE_EDITOR__TYPE_PLACEHOLDER' | transloco }}"
							style="margin-top: -16px"
						>
							<ion-select-option *ngFor="let type of types" value="{{ type.id }}">
								{{ type.name }}
							</ion-select-option>
						</ion-select>
					</app-grouping>
				</ng-container>
			}
		} @else {
			<div class="note-readonly" [class.note-readonly--v2]="isV2()">
				@if (noteTemplate == null) {
					<div class="note-editor-heading">{{ "NOTE_EDITOR__VIEW_NOTE" | transloco }}</div>
				}

				@if (canAcknowledgeHandover()) {
					<div class="note-acknowledge-hint">{{ "NOTE_EDITOR__HANDOVER_ACK_EXPLAINER" | transloco }}</div>
				}

				@if (isV2()) {
					<div class="note-editor-v2-readonly">
						@if (note.title) {
							<div class="note-editor-v2-field">
								<span class="note-editor-v2-field-label">
									{{ "NOTE_EDITOR__TITLE" | transloco }}
								</span>
								<div class="note-editor-v2-control note-editor-v2-control--disabled">
									{{ note.title }}
								</div>
							</div>
						}

						@if (note.description) {
							<div class="note-editor-v2-field">
								<span class="note-editor-v2-field-label">
									{{ "NOTE_EDITOR__DESCRIPTION" | transloco }}
								</span>
								<div
									class="note-editor-v2-control note-editor-v2-control--disabled note-editor-v2-control--multiline"
									[innerHTML]="note.description"
								></div>
							</div>
						}

						<div class="note-editor-v2-field">
							<span class="note-editor-v2-field-label">{{ "NOTE_EDITOR__TYPE" | transloco }}</span>
							<div class="note-editor-v2-control note-editor-v2-control--disabled">
								{{ note.type.name }}
							</div>
						</div>

						@if (note?.attachments?.length > 0) {
							<div class="note-editor-v2-field">
								<span class="note-editor-v2-field-label">
									{{ "NOTE_EDITOR__ADD_MEDIA" | transloco }}
								</span>
								<app-attachments
									formControlName="attachments"
									[showAttachments]="true"
									[hideHeadline]="true"
									[isReadonly]="true"
									[v2]="true"
								></app-attachments>
							</div>
						}
					</div>
				} @else {
					<div class="note-readonly-container">
						@if (note.title) {
							<app-grouping [label]="'NOTE_EDITOR__TITLE'">
								<div class="note-readonly-content">{{ note.title }}</div>
							</app-grouping>
						}

						@if (note.description) {
							<app-grouping [label]="'NOTE_EDITOR__DESCRIPTION'">
								<div class="note-readonly-content" [innerHTML]="note.description"></div>
							</app-grouping>
						}

						<app-grouping [label]="'NOTE_EDITOR__TYPE'">
							<div class="note-readonly-content">{{ note.type.name }}</div>
						</app-grouping>
					</div>
				}
			</div>
		}

		@if (!isV2() && (isCreateMode() || note?.attachments?.length > 0)) {
			<app-grouping [label]="'NOTE_EDITOR__ATTACH_MEDIA'">
				<app-attachments
					formControlName="attachments"
					[showAttachments]="true"
					[hideHeadline]="true"
					[isReadonly]="!isCreateMode()"
				></app-attachments>
			</app-grouping>
		}

		@if (isV2()) {
			<div class="note-editor-v2-actions">
				@if (isCreateMode()) {
					<button type="button" class="note-editor-v2-btn note-editor-v2-btn--outlined" (click)="close()">
						{{ "NOTE_EDITOR__CANCEL" | transloco }}
					</button>
				} @else {
					<button type="button" class="note-editor-v2-btn note-editor-v2-btn--outlined" (click)="close()">
						{{ "NOTE_EDITOR__CLOSE" | transloco }}
					</button>
				}

				@if (canAcknowledgeHandover()) {
					<button
						type="button"
						class="note-editor-v2-btn note-editor-v2-btn--filled"
						(click)="acknowledgeHandover()"
					>
						{{ "NOTE_EDITOR__ACKNOWLEDGE" | transloco }}
					</button>
				}

				@if (isCreateMode()) {
					<button
						type="submit"
						class="note-editor-v2-btn note-editor-v2-btn--filled"
						[disabled]="form.invalid"
					>
						{{ "NOTE_EDITOR__SAVE" | transloco }}
					</button>
				}
			</div>
		} @else {
			<div class="button-container">
				<div class="button-container-start">
					@if (isCreateMode()) {
						<ion-button color="light" shape="round" class="no-transform" (click)="close()">
							{{ "NOTE_EDITOR__CANCEL" | transloco }}
						</ion-button>
					} @else {
						<ion-button color="light" shape="round" class="no-transform" (click)="close()">
							{{ "NOTE_EDITOR__CLOSE" | transloco }}
						</ion-button>
					}
				</div>
				<div class="button-container-end">
					@if (canAcknowledgeHandover()) {
						<ion-button
							color="primary"
							shape="round"
							class="no-transform"
							type="button"
							(click)="acknowledgeHandover()"
						>
							{{ "NOTE_EDITOR__ACKNOWLEDGE" | transloco }}
						</ion-button>
					}

					@if (isCreateMode()) {
						<ion-button
							color="primary"
							shape="round"
							class="no-transform"
							type="submit"
							[disabled]="form.invalid"
						>
							{{ "NOTE_EDITOR__SAVE" | transloco }}
						</ion-button>
					}
				</div>
			</div>
		}
	</form>
</div>
